import {NavigationTabsModuleTabModel} from "./navigation-tabs-module.tab-model";
import type {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {APP} from "../../../../core/app/consts";
import type {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import {override} from "mobx";
import {ANALYTICS} from "../../../../third-party-services/analytics/analytics-consts";

export class InsightsTabModel extends NavigationTabsModuleTabModel {
  index: Number;
  name: String;
  entity: EntityViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: EntityViewModel,
    currentLinkModel: BaseLinkModel
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @override get isVisible(): Boolean {
    return true;
  }

  get eventParams(): Object {
    const eventParams = {
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[this.entity.objectType],
      entityId: this.entity.id,
      source: APP.ANALYTICS.SOURCES[this.currentLinkModel.name],
      sportTypeId: this.entity.sport.id
    }

    return eventParams;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.trends;
  }
}
